import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'lns-login-layout',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './login-layout.component.html'
})
export class LoginLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
